/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_TitleInputs */

const vi_grower_title = /** @type {(inputs: Grower_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hộ trồng chè`)
};

/**

* @param {Grower_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_title = /** @type {((inputs?: Grower_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_title(inputs)
});